import {observable, computed, action, autorun} from 'mobx';
import m from 'moment';
import {firebaseRefs} from 'store/FirebaseStore';
import Event from './Event';
import Person from './Person';

const beeperRef = firebaseRefs.beeper;
const allPerson = {firstName: 'Kõik', lastName: 'Töötajad', key: 'no'};
const unknownPerson = {firstName: 'Tundmatu', lastName: 'Isik', key: 'no'};

class BeeperStore {
  @observable people = observable.map({});
  @observable selectedPerson = {id: 'all'};
  @observable events = observable.map({});
  @observable startDate = m().startOf('day').toDate();
  @observable endDate = m().endOf('day').toDate();
  @observable editableEvent = {};
  @observable editing = false;
  routeInfo = null;

  // returns an object with the selectedPerson as a key
  // If selectedPerson is 'all' returns a key for every person that had an event in the data
  @computed get activePersons() {
    const activePersons = [];
    if (this.selectedPerson && this.selectedPerson.id === 'all') {
      this.people.forEach(person => {

        if (person.events.length > 0) {
          activePersons.push(person);
        }
      });
    } else if (this.selectedPerson) {
      activePersons.push(this.selectedPerson);
    }
    return activePersons;
  }

  @computed get peopleList() {
    const peopleList = [];
    peopleList.push({value: 'all', label: 'Kõik Töötajad'});
    peopleList.push({value: 'unknown', label: 'Tundmatu'});
    this.people.forEach(person => peopleList.push({value: person.id, label: person.fullName}));
    return peopleList;
  }

  constructor(routeInfo) {
    this.routeInfo = routeInfo;
    // console.log('created store');
  }

  startListeners() {
    beeperRef.people.on('value', action('addPeople', snapshot => {
      this.people.clear();
      // this.addPerson('all', allPerson);
      // this.addPerson('unknown', unknownPerson);
      snapshot.forEach(snap => {
        this.addPerson(snap.key, snap.val());
      })
    }));

    autorun(() => {
      if (this.startDate && this.endDate) {
        console.log(`getting events: ${m(this.startDate).format('LL')} to ${m(this.endDate).format('LL')}`);

        beeperRef.events.off();
        const beeperEvents = beeperRef.events
          .orderByChild('time')
          .startAt(this.startDate.getTime() / 1000)
          .endAt(this.endDate.getTime() / 1000);

        beeperEvents.once('value', snapshot => {
          const events = [];
          snapshot.forEach(snap => {
            events.push({id: snap.key, ...snap.val()});
          });
          this.addEvents(events);

          beeperEvents.on('child_added', snap => {
            if (!this.events.has(snap.key)) {
              console.log('child_added');
              this.addEvent({id: snap.key, ...snap.val()});
            }
          });

          beeperEvents.on('child_removed', snap => {
            this.removeEvent({id: snap.key, ...snap.val()});
          });

          beeperEvents.on('child_changed', snap => {
            this.editEvent({id: snap.key, ...snap.val()});
          });
        });
      }
    });
  }

  stopListeners() {
    beeperRef.events.off();
    beeperRef.people.off();
  }

  addEventToFB(event) {
    beeperRef.events.push(event);
  }

  editEventInFB(id, event) {
    beeperRef.events.child(id).set(event);
  }

  deleteEventFromFB(id) {
    beeperRef.events.child(id).remove();
  }

  @action addPerson(key, person) {
    this.people.set(key, new Person(key, person, this));
  }

  @action removePerson(key) {
    this.people.delete(key);
  }

  @action addEvent(event) {
    this.events.set(event.id, new Event(event));
  }

  @action addEvents(events) {
    this.events.clear();
    events.forEach(event => this.addEvent(event));
  }

  @action editEvent(event) {
    console.log('editing event', event);
    this.addEvent(event);
  }

  @action removeEvent(event) {
    console.log('removing event', event);
    this.events.delete(event.id);
  }

  @action setStartDate = date => {
    this.startDate = date.toDate();
  };

  @action setEndDate = date => {
    this.endDate = date.toDate();
  };

  @action setDates = (startDate, endDate) => {
    this.setStartDate(startDate);
    this.setEndDate(endDate);
  };

  @action setSelectedPerson = person => {
    this.selectedPerson = person;
  };

  @action toggleEditing = () => {
    this.editing = !this.editing;
  };

  @action setEditableEvent = (event) => {
    this.editableEvent = new Event(event);
  };

  convertToHours = (time) => {
    return `${Math.floor(m.duration(time).asHours())}${m.utc(time).format(':mm:ss')}`;
  };


}

export default BeeperStore;


// WEBPACK FOOTER //
// ./src/views/Beeper/BeeperStore.js